import { getCurations as getCurationsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetCurationsServiceRequest, GetCurationsServiceResponse } from './get-curations.dto';
import {
  GetCurationsServiceRequestSchema,
  GetCurationsServiceResponseSchema,
} from './get-curations.dto';

export const getCurationsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetCurationsServiceRequestSchema),
    async (request: GetCurationsServiceRequest): Promise<GetCurationsServiceResponse> => {
      const apiResponse = await getCurationsApi(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '큐레이터 상품 조회에 실패했습니다.');
      }

      const hasNextPage = apiResponse.link?.next !== null && apiResponse.link?.next !== undefined;
      const nextPage = hasNextPage ? request.page + 1 : undefined;

      const transformedList = apiResponse.data.list.map((item) => ({
        ...item,
        curationId: String(item.curationId),
        goodsItems: item.goodsItems.map((goodsItem) => ({
          ...goodsItem,
          goodsNo: goodsItem.goodsNo.toString(),
          extraDiscountAmount: goodsItem.extraDiscountAmount ?? 0,
          finalPrice: goodsItem.finalPrice ?? goodsItem.couponPrice ?? goodsItem.price,
          finalDiscount:
            goodsItem.finalDiscount ?? goodsItem.couponSalesRate ?? goodsItem.salesRate ?? 0,
          isLowestPrice: goodsItem.isLowestPrice ?? false,
          isExclusive: goodsItem.isExclusive ?? false,
          hasNextPage,
          nextPage,
        })),
      }));

      return {
        total:
          apiResponse.link && 'total' in apiResponse.link
            ? ((apiResponse.link as { total: number | null }).total ?? 0)
            : 0,
        list: transformedList,
        pagination: {
          currentPage: request.page,
          pageSize: request.size,
          hasNextPage,
          nextPage,
        },
      };
    },
    validateServiceResponse(GetCurationsServiceResponseSchema),
  ),
);
